import React from "react"
import PropTypes from "prop-types"
import Widget from "../layout/widget/Widget"
import PieChart from "../charts/generic/PieChart"

function ReadyToMove({ exportEndpoint, appliedFilters, data, subtitleKey, sampleSize }) {
  const titleKey = "Widgets.ReadyToProgress.Title"
  return (
    <Widget
      columns={1}
      titleKey={titleKey}
      helpKey="Widgets.ReadyToProgress.Help"
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
      subtitleKey={subtitleKey}
      sampleSize={sampleSize}
    >
      <PieChart data={data} singularTooltipDescriptorKey="Common.Person" pluralTooltipDescriptorKey="Common.People" titleKey={titleKey} subtitleKey={subtitleKey}/>
    </Widget>
  )
}

ReadyToMove.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    key: PropTypes.string,
  })).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string,
  sampleSize: PropTypes.object
}

ReadyToMove.defaultProps = {
  subtitleKey: null,
}

export default ReadyToMove



// WEBPACK FOOTER //
// ./src/components/widgets/ReadyToMove.jsx